import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Auslandsadresse, Grossempfaengeradresse, Inlandsadresse, Postfachadresse, EntsprichtWohnanschrift} from '@nachdigal';

@Component({
    selector: 'common-ui-adresserfassung',
    templateUrl: './adresserfassung.component.html'
})
export class AdresserfassungComponent implements OnInit {

    @Input()
    public index: number;
    @Input()
    public enableGrossempfaengeradresse = false;
    @Input()
    public singleMode = false;
    @Input()
    public noAddressRequired = false;
    @Input()
    public readonly;
    @Input()
    public optionalInlandsadresse = false;
    @Input()
    public stammdatenInlandsadresse: Array<Inlandsadresse>;
    @Input()
    public stammdatenAuslandsAdresse: Array<Auslandsadresse>;
    @Input()
    public stammdatenPostfachadresse: Array<Postfachadresse>;
    @Input()
    public stammdatenGrossempfaengeradresse: Array<Grossempfaengeradresse>;
    @Input()
    public hideInlandsadresse = false;
    @Input()
    public inlandOrtLocalzation: string;
    @Input()
    public inlandRequiredStrasse = false;
    @Input()
    public inlandRequiredHausnumer = false;
    @Input()
    public auslandRequiredStrasse = false;
    @Input()
    public auslandRequiredHausnumer = false;

    @Output()
    public entsprichtWohnanschriftChange: EventEmitter<EntsprichtWohnanschrift> = new EventEmitter<EntsprichtWohnanschrift>();
    @Output()
    public inlandsadresseChange: EventEmitter<Inlandsadresse> = new EventEmitter<Inlandsadresse>();
    @Output()
    public auslandsadresseChange: EventEmitter<Auslandsadresse> = new EventEmitter<Auslandsadresse>();
    @Output()
    public postfachadresseChange: EventEmitter<Postfachadresse> = new EventEmitter<Postfachadresse>();
    @Output()
    public grossempfaengeradresseChange: EventEmitter<Grossempfaengeradresse> = new EventEmitter<Grossempfaengeradresse>();
    @Output()
    public showInlandsadresseChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    public showInlandsAdresse = true;
    public showAuslandsAdresse = false;
    public showPostfachAdresse = false;
    public showGrossempfaengerAdresse = false;

    private internalEntsprichtWohnanschrift: EntsprichtWohnanschrift;
    private internalEntsprichtWohnanschriftLabel = '';
    private internalInlandsadresse: Inlandsadresse;
    private internalAuslandsadresse: Auslandsadresse;
    private internalPostfachadresse: Postfachadresse;
    private internalGrossempfaengeradresse: Grossempfaengeradresse;
    private internalDisableAuslandsadresse = false;
    private internalDisablePostfachadresse = false;

    public get disablePostfachadresse(): boolean {
        return this.internalDisablePostfachadresse;
    }

    @Input()
    public set disablePostfachadresse(value: boolean) {
        this.internalDisablePostfachadresse = value;
        if (value === true) {
            this.showPostfachAdresse = false;
        }
        this.showInlandAddresseIfNeeded();
    }

    public get disableAuslandsadresse(): boolean {
        return this.internalDisableAuslandsadresse;
    }

    @Input()
    public set disableAuslandsadresse(value: boolean) {
        this.internalDisableAuslandsadresse = value;
        if (value === true) {
            this.showAuslandsAdresse = false;
        }
        this.showInlandAddresseIfNeeded();
    }

    public get entsprichtWohnanschrift(): EntsprichtWohnanschrift {
        return this.internalEntsprichtWohnanschrift;
    }

    @Input()
    public set entsprichtWohnanschrift(value: EntsprichtWohnanschrift) {
        this.internalEntsprichtWohnanschrift = value;
    }

    public get entsprichtWohnanschriftLabel(): string {
        return this.internalEntsprichtWohnanschriftLabel;
    }

    @Input()
    public set entsprichtWohnanschriftLabel(value: string) {
        this.internalEntsprichtWohnanschriftLabel = value;
    }

    public get inlandsadresse(): Inlandsadresse {
        return this.internalInlandsadresse;
    }

    @Input()
    public set inlandsadresse(value: Inlandsadresse) {
        this.internalInlandsadresse = value;

        if (!value && this.auslandsadresse) {
            this.showInlandsAdresse = false;
        }

        if (value && this.optionalInlandsadresse) {
            this.showInlandsAdresse = true;
        }

        this.showInlandsadresseChange.emit(this.showInlandsAdresse);
    }

    public get auslandsadresse(): Auslandsadresse {
        return this.internalAuslandsadresse;
    }

    @Input()
    public set auslandsadresse(value: Auslandsadresse) {
        this.internalAuslandsadresse = value;
        let showAuslandAddress = !!value?.adressergaenzung || !!value?.hausnummer || !!value?.hausnummernzusatz ||
            !!value?.land;
        showAuslandAddress = showAuslandAddress || !!value?.ort || !!value?.postleitzahl || !!value?.strasse;
        this.showAuslandsAdresse = showAuslandAddress;
    }

    public get postfachadresse(): Postfachadresse {
        return this.internalPostfachadresse;
    }

    @Input()
    public set postfachadresse(value: Postfachadresse) {
        this.internalPostfachadresse = value;
        this.showPostfachAdresse = !(!value?.ort && !value?.postleitzahl && !value?.postfach);
    }

    public get grossempfaengeradresse(): Grossempfaengeradresse {
        return this.internalGrossempfaengeradresse;
    }

    @Input()
    public set grossempfaengeradresse(value: Grossempfaengeradresse) {
        this.internalGrossempfaengeradresse = value;
        this.showGrossempfaengerAdresse = !(!value?.ort && !value?.postleitzahl);
    }

    public ngOnInit(): void {
        this.inlandsadresse = this.internalInlandsadresse;
        if ((this.hideInlandsadresse || this.optionalInlandsadresse) && !this.inlandsadresse) {
            this.showInlandsAdresse = false;
            this.showInlandsadresseChange.emit(false);
        }
    }

    private showInlandAddresseIfNeeded(): void {
        if (this.internalDisableAuslandsadresse && this.internalDisablePostfachadresse) {
            this.showInlandsAdresse = true;
        }
    }

    public onEntsprichtWohnanschriftClick($event: EntsprichtWohnanschrift): void {
        if ($event.entsprichtWohnanschrift) {
            if (!!this.inlandsadresse) {
                this.inlandsadresse = null;
                this.inlandsadresseChange.emit(null);
            }
            if (!!this.auslandsadresse) {
                this.auslandsadresse = null;
                this.auslandsadresseChange.emit(null);
            }
            if (!!this.postfachadresse) {
                this.postfachadresse = null;
                this.postfachadresseChange.emit(null);
            }
            if (!!this.grossempfaengeradresse) {
                this.grossempfaengeradresse = null;
                this.grossempfaengeradresseChange.emit(null);
            }
        }
    }

}
